import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IAutoTest } from './model';

export interface IQuestionResult {
  isRight: boolean;
  rightAnswer: number | null;
  selectedAnswer: number;
}

interface IStore {
  test: IAutoTest | null;
  isRunning: boolean;
  isRight: boolean;
  rightAnswer: number | null;
  answers: Record<number, IQuestionResult>;
  currentQuestionIndex: number;
  isAutoFinishTriggered: boolean;
}

const initialState: IStore = {
  test: null,
  isRunning: false,
  isRight: false,
  rightAnswer: null,
  answers: {},
  currentQuestionIndex: 0,
  isAutoFinishTriggered: false
};

const autoTest = createSlice({
  name: 'auto-test',
  initialState,
  reducers: {
    setTestData(state, action: PayloadAction<IAutoTest>) {
      state.test = action.payload;
    },
    setCurrentQuestionIndex(state, action: PayloadAction<number>) {
      state.currentQuestionIndex = action.payload;
    },
    setAnswerResult: (
      state,
      action: PayloadAction<{
        questionId: number;
        isRight: boolean;
        rightAnswer: number;
        selectedAnswer?: number;
      }>
    ) => {
      const { questionId, isRight, rightAnswer, selectedAnswer } = action.payload;

      state.answers[questionId] = { isRight, rightAnswer, selectedAnswer: selectedAnswer ?? -1 };
    },
    resetTestResults: state => {
      state.answers = {};
    },
    resetTestData: state => {
      state.test = null;
    },
    setAllAnswers: (state, action: PayloadAction<Record<number, IQuestionResult>>) => {
      state.answers = action.payload;
    },
    setIsAutoFinishTriggered(state, action: PayloadAction<boolean>) {
      state.isAutoFinishTriggered = action.payload;
    }
  }
});

export const { setTestData, setAnswerResult, resetTestResults, setCurrentQuestionIndex, setAllAnswers, resetTestData, setIsAutoFinishTriggered } =
  autoTest.actions;
export const autoTestReducer = autoTest.reducer;
